import { computed } from 'vue';

export const isYousignSandbox = computed(
  () => String(import.meta.env.VITE_YOUSIGN_IS_SANDBOX).toLowerCase() === 'true'
);
